import {
  BLOG_FREE_DATA,
  BLOG_SET_CURRENT_RECORD,
  BLOG_CLEAR_RECORDS_LIST,
  BLOG_GET_RECORDS_LIST, // Получение списка записей блога, согласно установленному текущему фильтру
  BLOG_GET_STATES_LIST, // Получение списка записей блога, согласно установленному текущему фильтру
  BLOG_CREATE_RECORD,
  BLOG_UPDATE_RECORD,
  BLOG_CANCEL_RECORD,
  BLOG_POST_RECORD,
  BLOG_ADD_FILE,
  BLOG_DEL_FILE,
  BLOG_SET_CURRENT_STATUS

} from '../actions/blog'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
import axios from 'axios'
const state = {
  currentRecord: {},
  currentStatus: null,
  recordList: [],
  statusList: []
}

const getters = {
  getCurrentRecordID: state => state.currentRecord.DOC_ID,
  getCurrentRecord: state => state.currentRecord,
  getCurrentBIStateFilter: state => state.currentStatus,
  getCurrentBIStateList: state => state.statusList,
  getCurrentRecordFiles: state => {
    if (typeof state.currentRecord.FILE_LIST !== 'undefined') {
      return state.currentRecord.FILE_LIST
    } else {
      return []
    }
  },
  getCurrentRecordAvailStates: state => {
    if (typeof state.currentRecord.AVAIL_STATUS !== 'undefined') {
      return state.currentRecord.AVAIL_STATUS
    } else {
      return []
    }
  },
  getCurrentRecordsList: state => state.recordList

}

const actions = {
  [BLOG_FREE_DATA]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      commit(BLOG_FREE_DATA)
      resolve('success')
    }),

  [BLOG_GET_RECORDS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'BLOG_GET_RECORDS_LIST', topic: 'Загрузка списка записей', error: null })
      console.log('Called action BLOG_GET_RECORDS_LIST')
      if (state.currentStatus !== null) {
        commit(BLOG_CLEAR_RECORDS_LIST)
        axios({ url: '/api/org/blog/getRecords.php', data: { DS_ID: state.currentStatus }, method: 'POST' })
          .then(resp => {
            if (resp.data.error === 'ok') {
              commit(BLOG_GET_RECORDS_LIST, resp.data.data)
              dispatch(UI_SUCCESS, { action: 'BLOG_GET_RECORDS_LIST' })
              resolve(resp.data.data)
            } else {
              dispatch(UI_ERROR, { action: 'BLOG_GET_RECORDS_LIST', result: 'Ошибка получения списка записей: ' + resp.data.error_text })
              reject(resp.data.error_text)
            }
          })
          .catch((err) => {
            dispatch(UI_ERROR, { action: 'BLOG_GET_RECORDS_LIST', result: 'Получение списка записей: ошибка сервера' })
            reject(new Error(err))
          })
      } else {
        dispatch(UI_SUCCESS, { action: 'BLOG_GET_RECORDS_LIST' })
        resolve()
      }
    }),

  [BLOG_GET_STATES_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'BLOG_GET_STATES_LIST', topic: 'Загрузка списка статусов записей', error: null })
      console.log('Called action BLOG_GET_STATES_LIST')
      axios({ url: '/api/org/blog/getRecordStatusList.php', data: {}, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(BLOG_GET_STATES_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'BLOG_GET_STATES_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'BLOG_GET_STATES_LIST', result: 'Ошибка получения списка записей: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'BLOG_GET_STATES_LIST', result: 'Получение списка записей: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [BLOG_SET_CURRENT_RECORD]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action BLOG_SET_CURRENT_RECORD ', requestItem)
      dispatch(UI_REQUEST, { action: 'BLOG_SET_CURRENT_RECORD', topic: 'Установка активной записи', error: null })
      if (requestItem.DOC_ID !== state.currentRecord.DOC_ID) {
        console.log('Setting new current request', requestItem)
        commit(BLOG_SET_CURRENT_RECORD, requestItem)
      }
      dispatch(UI_SUCCESS, { action: 'BLOG_SET_CURRENT_RECORD' })
      resolve()
    }),
  [BLOG_SET_CURRENT_STATUS]: ({ commit, dispatch }, newStatus) =>
    new Promise((resolve, reject) => {
      console.log('Called action BLOG_SET_CURRENT_STATUS ', newStatus)
      dispatch(UI_REQUEST, { action: 'BLOG_SET_CURRENT_STATUS', topic: 'Установка активного статуса', error: null })
      if (state.currentStatus !== newStatus) {
        console.log('Setting new current status', newStatus)
        commit(BLOG_SET_CURRENT_STATUS, newStatus)
        dispatch(BLOG_GET_RECORDS_LIST)
      }
      dispatch(UI_SUCCESS, { action: 'BLOG_SET_CURRENT_STATUS' })
      resolve()
    }),
  [BLOG_CREATE_RECORD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'BLOG_CREATE_RECORD', topic: 'Создание записи', error: null })
      axios({ url: '/api/org/blog/createNewRecord.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(BLOG_CREATE_RECORD, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'BLOG_CREATE_RECORD' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'BLOG_CREATE_RECORD', result: 'Создание записи: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'BLOG_CREATE_RECORD', result: 'Создание записи: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [BLOG_UPDATE_RECORD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'BLOG_UPDATE_RECORD', topic: 'Обновление записи', error: null })
      axios({ url: '/api/org/blog/updateRecord.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(BLOG_UPDATE_RECORD, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'BLOG_UPDATE_RECORD' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'BLOG_UPDATE_RECORD', result: 'Обновление записи: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'BLOG_UPDATE_RECORD', result: 'Обновление записи: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [BLOG_CANCEL_RECORD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'BLOG_CANCEL_RECORD', topic: 'Отмена записи', error: null })
      console.log('BLOG_CANCEL_RECORD action called')
      dispatch(BLOG_POST_RECORD, params)
        .then(resp => {
          console.log('BLOG_POST_RECORD returned responce to BLOG_CANCEL_RECORD', resp)
          if (resp.error === 'ok') {
            console.log('BLOG_CANCEL_RECORD result is OK, commiting BLOG_CANCEL_RECORD mutation')
            commit(BLOG_CANCEL_RECORD, params)
            resolve()
            dispatch(UI_SUCCESS, { action: 'BLOG_CANCEL_RECORD' })
          } else {
            dispatch(UI_ERROR, { action: 'BLOG_CANCEL_RECORD', result: 'Обновление данных по состоянию записи: ошибка сервера' })
            reject(new Error(resp.error_text))
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'BLOG_CANCEL_RECORD', result: 'Обновление данных по состоянию записи: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [BLOG_POST_RECORD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'BLOG_POST_RECORD', topic: 'Изменение состояния записи', error: null })
      axios({ url: '/api/org/blog/postRecord.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(BLOG_POST_RECORD, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'BLOG_POST_RECORD' })
          } else {
            dispatch(UI_ERROR, { action: 'BLOG_POST_RECORD', result: 'Ошибка отправки запроса : ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'BLOG_POST_RECORD', result: 'Ошибка отправки запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [BLOG_ADD_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'BLOG_ADD_FILE', topic: 'Добавление файла в запись', error: null })
      axios({ url: '/api/org/blog/uploadRecordDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(BLOG_ADD_FILE, resp.data.data)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'BLOG_ADD_FILE' })
          } else {
            dispatch(UI_ERROR, { action: 'BLOG_ADD_FILE', result: 'Ошибка добавления файла в запись: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'BLOG_ADD_FILE', result: 'Добавление данных в запись: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [BLOG_DEL_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'BLOG_DEL_FILE', topic: 'Удаление файла из записи', error: null })
      axios({ url: '/api/org/blog/delRecordFile.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(BLOG_DEL_FILE, params)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'BLOG_DEL_FILE' })
          } else {
            dispatch(UI_ERROR, { action: 'BLOG_DEL_FILE', result: 'Удаление файла из записи: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'BLOG_ADD_FILE', result: 'Удаление файла из записи: ошибка сервера' })
          reject(new Error(err))
        })
    })
}

const mutations = {

  [BLOG_FREE_DATA]: state => {
    state.currentRecord = {}
    state.currentStatus = null
    state.recordList.splice(0, state.recordList.length)
    state.statusList.splice(0, state.statusList.length)
  },
  [BLOG_CLEAR_RECORDS_LIST]: (state) => {
    console.log('BLOG_CLEAR_RECORDS_LIST mutation initiated, ')
    state.recordList.splice(0, state.recordList.length)
  },
  [BLOG_GET_RECORDS_LIST]: (state, resp) => {
    console.log('BLOG_GET_RECORDS_LIST mutation initiated, ', resp)
    state.currentRecord = {}
    state.recordList = resp
  },
  [BLOG_GET_STATES_LIST]: (state, resp) => {
    console.log('BLOG_GET_STATES_LIST mutation initiated, ', resp)
    state.statusList = resp
  },
  [BLOG_SET_CURRENT_RECORD]: (state, resp) => {
    console.log('BLOG_SET_CURRENT_RECORD mutation initiated, ', resp)
    state.currentRecord = resp
  },
  [BLOG_SET_CURRENT_STATUS]: (state, resp) => {
    console.log('BLOG_SET_CURRENT_STATUS mutation initiated, ', resp)
    state.currentStatus = resp
  },
  [BLOG_CREATE_RECORD]: (state, orderItem) => {
    console.log('BLOG_CREATE_RECORD mutation initiated', orderItem)
    state.recordList.push(orderItem)
  },
  [BLOG_UPDATE_RECORD]: (state, orderItem) => {
    console.log('BLOG_UPDATE_RECORD mutation initiated', orderItem)
    const index = state.recordList.findIndex(itm => itm.DOC_ID === orderItem.DOC_ID)
    if (index !== -1) {
      state.recordList.splice(index, 1, orderItem)
      state.currentRecord = orderItem
    }
  },
  [BLOG_CANCEL_RECORD]: (state, resp) => {
    console.log('BLOG_CANCEL_RECORD mutation called. RESP is ', resp)
    var BLOGIndex = state.recordList.findIndex(BLOG => BLOG.DOC_ID === resp.DOC_ID)
    if (BLOGIndex !== -1) {
      state.recordList.splice(BLOGIndex, 1)
    }
  },
  [BLOG_POST_RECORD]: (state, resp) => {
    console.log('BLOG_POST_RECORD mutation called. RESP is ', resp, 'Current record id is ', state.currentRecord.DOC_ID)
    const index = state.recordList.findIndex(itm => itm.DOC_ID === resp.DOC_ID)
    if (index !== -1) {
      if (state.recordList[index].DS_ID === resp.DS_ID) {
        state.recordList.splice(index, 1, resp)
      } else {
        state.recordList.splice(index, 1)
      }
      state.currentRecord = resp
    }
  },
  [BLOG_ADD_FILE]: (state, responce) => {
    console.log('BLOG_ADD_FILE mutation called, payload ', responce)
    state.currentRecord.FILE_LIST.push(responce)
  },
  [BLOG_DEL_FILE]: (state, responce) => {
    console.log('BLOG_DEL_FILE mutation called, payload ', responce)
    const index = state.currentRecord.FILE_LIST.findIndex(itm => itm.DD_ID === responce.DD_ID)
    state.currentRecord.FILE_LIST.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
